export default __webpack_public_path__ + "static/media/3.967ce776.png";